import { sendLog } from '@/utils/logstore';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('sendLog', sendLog)
})
